import { Component, computed, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router } from '@angular/router';
import { map } from 'rxjs';
import { Payouts } from './tabs/payouts/payouts';
import { Tax } from './tabs/tax/tax';
import { Moderate } from './tabs/moderate/moderate';
import { Faq } from './tabs/faq/faq';
import { Inspired } from './tabs/inspired/inspired';
import { AdminOptionsNav, AdminOptionsTabId } from './admin-options-nav';

@Component({
  selector: 'app-admin-options',
  imports: [Payouts, Tax, Moderate, Faq, Inspired, AdminOptionsNav],
  templateUrl: './admin-options.html',
  styleUrl: './admin-options.scss',
  host: { class: 'block h-full w-full min-w-0' },
})
export class AdminOptions implements OnInit {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private destroyRef = inject(DestroyRef);

  private tabIdParam = toSignal(
    this.route.paramMap.pipe(map((params) => params.get('tabId'))),
    { initialValue: this.route.snapshot.paramMap.get('tabId') },
  );

  selectedTab = computed<AdminOptionsTabId>(() => {
    const tab = this.tabIdParam();
    if (tab && this.isAdminOptionsTabId(tab)) {
      return tab;
    }
    return 'payouts';
  });

  ngOnInit(): void {
    const tab = this.route.snapshot.paramMap.get('tabId');

    if (tab === 'settings') {
      void this.router.navigate(['/admin-options/settings'], { replaceUrl: true });
      return;
    }

    if (tab === 'branding') {
      void this.router.navigate(['/admin-options/branding'], { replaceUrl: true });
      return;
    }

    if (tab === 'google-analytics') {
      void this.router.navigate(['/admin-options/google-analytics'], { replaceUrl: true });
      return;
    }

    if (!tab && this.router.url.split('?')[0] === '/admin-options') {
      void this.router.navigate(['/admin-options/payouts'], { replaceUrl: true });
    }

    this.route.paramMap
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((params) => {
        const tabId = params.get('tabId');
        if (tabId === 'settings') {
          void this.router.navigate(['/admin-options/settings'], { replaceUrl: true });
        }
        if (tabId === 'branding') {
          void this.router.navigate(['/admin-options/branding'], { replaceUrl: true });
        }
        if (tabId === 'google-analytics') {
          void this.router.navigate(['/admin-options/google-analytics'], { replaceUrl: true });
        }
      });
  }

  private isAdminOptionsTabId(value: string): value is AdminOptionsTabId {
    return (
      value === 'payouts' ||
      value === 'tax' ||
      value === 'moderate' ||
      value === 'faq' ||
      value === 'inspired'
    );
  }
}
